import { Button, IconPicker, Spinner } from '@assembly-js/design-system';
import { useCallback, useState } from 'react';

import { iconPickerClassName } from 'src/components/icons';
import { useSuggestIconMutation } from 'src/services/api/applicationsApi';

interface SuggestIconPickerProps {
  value: string;
  onChange: (iconName: string) => void;
  appName: string;
  className?: string;
}

export const SuggestIconPicker = ({
  value = 'dashboard',
  onChange,
  appName,
  className,
}: SuggestIconPickerProps) => {
  const [isSuggesting, setIsSuggesting] = useState(false);
  const [suggestIcon] = useSuggestIconMutation();

  const renderSuggestAction = useCallback(
    (closePopover: () => void) => (
      <Button
        variant="secondary"
        size="sm"
        label="Suggest icon"
        className="h-8 whitespace-nowrap"
        onClick={() => {
          closePopover();
          setIsSuggesting(true);
          suggestIcon({ appName })
            .unwrap()
            .then((result) => {
              onChange(result.icon);
            })
            .catch(() => {
              // silently fail — icon remains unchanged
            })
            .finally(() => {
              setIsSuggesting(false);
            });
        }}
      />
    ),
    [appName, onChange, suggestIcon],
  );

  if (isSuggesting) {
    return (
      <div className={`flex items-center justify-center ${className ?? ''}`}>
        <Spinner size={5} />
      </div>
    );
  }

  return (
    <IconPicker
      className={className ?? iconPickerClassName}
      value={value}
      onChange={onChange}
      inlineAction={renderSuggestAction}
    />
  );
};
